import { useEffect } from "react";
import { login } from "../auth";

function LoginRedirect() {
  useEffect(() => {
    login();
  }, []);

  return <p>Redirecting to login...</p>;
}

export default LoginRedirect;
